import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { testimonials } from '../data/mock';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-4">
            Testimonials
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            Trusted by Industry{' '}
            <span className="text-amber-500">Leaders</span>
          </h2>
          <p className="text-lg text-slate-600">
            See what our partners and clients say about working with Axiom Global Freight.
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative max-w-4xl mx-auto">
          <Card className="bg-slate-50 border-0 shadow-xl overflow-hidden">
            <CardContent className="p-8 sm:p-12">
              <Quote className="w-12 h-12 text-amber-500/30 mb-6" />
              
              <div className="min-h-[150px] flex items-center">
                <p className="text-xl sm:text-2xl text-slate-700 leading-relaxed italic">
                  &ldquo;{testimonials[activeIndex].quote}&rdquo;
                </p>
              </div>

              <div className="mt-8 flex items-center justify-between">
                <div>
                  <div className="font-bold text-slate-900 text-lg">
                    {testimonials[activeIndex].author}
                  </div>
                  <div className="text-slate-500">
                    {testimonials[activeIndex].role}, {testimonials[activeIndex].company}
                  </div>
                </div>

                {/* Navigation */}
                <div className="flex items-center gap-2">
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={prevTestimonial}
                    className="rounded-full border-slate-300 hover:bg-amber-50 hover:border-amber-300"
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </Button>
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={nextTestimonial}
                    className="rounded-full border-slate-300 hover:bg-amber-50 hover:border-amber-300"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </Button>
                </div>
              </div>

              {/* Dots */}
              <div className="flex justify-center gap-2 mt-8">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                      index === activeIndex
                        ? 'bg-amber-500 w-8'
                        : 'bg-slate-300 hover:bg-slate-400'
                    }`}
                  />
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
